/**
 * near-me-schema — Public API
 * ===========================
 * Shared Zod schemas, enums and taxonomy for the Near-Me local-business
 * service. Single SSOT consumed by both reform-backend and jansathi-frontend.
 */

// ─── Business schemas + wire types ───────────────────────────────────────────
export {
  branchSchema,
  type CreateBusinessInput,
  contactSchema,
  createBusinessBaseSchema,
  createBusinessSchema,
  dayHoursSchema,
  type MyBusinessesQuery,
  myBusinessesQuerySchema,
  type NearMeBranch,
  type NearMeBusiness,
  type NearMeBusinessSearchResult,
  type NearMeContact,
  type NearMeDayHours,
  type SearchBusinessesQuery,
  searchBusinessesQuerySchema,
  type UpdateBusinessInput,
  updateBusinessSchema,
} from './business.schema.js';
// ─── Enums ───────────────────────────────────────────────────────────────────
export {
  NEAR_ME_DAY,
  NEAR_ME_LEAD_STATUS,
  NEAR_ME_LEAD_TYPE,
  NEAR_ME_REPORT_REASON,
  NEAR_ME_STATUS,
  NEAR_ME_TAG,
  type NearMeDay,
  type NearMeLeadStatus,
  type NearMeLeadType,
  type NearMeReportReason,
  type NearMeStatus,
  type NearMeTag,
} from './enums.js';
// ─── Helpers ─────────────────────────────────────────────────────────────────
export {
  emptyStringToUndefined,
  type GeoJsonPoint,
  geoJsonPointSchema,
  optionalEmailSchema,
  optionalPhoneSchema,
  optionalTrimmedString,
  optionalUrlSchema,
  phoneSchema,
  timeOfDaySchema,
} from './helpers.js';
// ─── Lead schemas + wire types ───────────────────────────────────────────────
export {
  type CreateLeadInput,
  createLeadBodySchema,
  type MyLeadsQuery,
  myLeadsQuerySchema,
  type NearMeLead,
  type NearMeLeadListResult,
  OWNER_LEAD_STATUSES,
  type UpdateLeadStatusInput,
  updateLeadStatusBodySchema,
} from './lead.schema.js';
// ─── Plans: limits + pricing + feature matrix ────────────────────────────────
export {
  type FeatureChipDisplay as NearMeFeatureChipDisplay,
  type FeatureDisplayItem as NearMeFeatureDisplayItem,
  type FeatureDisplayValue as NearMeFeatureDisplayValue,
  type FeaturePlanCell as NearMeFeaturePlanCell,
  getNearMePlanFeatureDisplay,
  NEAR_ME_PLAN_FEATURE_DISPLAY_DATA,
} from './plan-features-data.js';
export {
  type BooleanFeatureKey as NearMeBooleanFeatureKey,
  type FeatureKey as NearMeFeatureKey,
  getNearMePlanLimit,
  isNearMeFeatureEnabled,
  isNearMeUnlimited,
  NEAR_ME_PLAN_ID,
  NEAR_ME_PLAN_LIMITS,
  NEAR_ME_UNLIMITED,
  type NearMePlanId,
  type NearMePlanLimits,
  type NumericFeatureKey as NearMeNumericFeatureKey,
} from './plan-limits.js';
export {
  NEAR_ME_TENURE_ID,
  type NearMeLaunchOffer,
  type NearMePricingPlanResponse,
  type NearMePricingPlansListResult,
  type NearMeTenureId,
  type NearMeTenureVariation,
} from './pricing-plan.js';
// ─── Review schemas + wire types ─────────────────────────────────────────────
export {
  type CreateReviewInput,
  createReviewBodySchema,
  type NearMeReview,
  type NearMeReviewListResult,
  type OwnerRespondInput,
  ownerRespondBodySchema,
  type ReviewsQuery,
  reviewsQuerySchema,
} from './review.schema.js';
// ─── Taxonomy ────────────────────────────────────────────────────────────────
export {
  isSubcategoryOfCategory,
  NEAR_ME_CATEGORY,
  NEAR_ME_CATEGORY_SUBCATEGORIES,
  NEAR_ME_SUBCATEGORY,
  type NearMeCategory,
  type NearMeSubcategory,
  subcategoriesForCategory,
} from './taxonomy.js';
